const orderList = {
  path: "order_list",
  component: (resolve) =>
    require(["@/pages/admin/storage_audit/order_list.vue"], resolve),
};

export default orderList;
